export default __webpack_public_path__ + "static/media/background.7c1f5e58.svg";